import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';

export interface IProgressStep {
    stepTitle: string;
    link?: string;
    active: boolean;
    name?: string;
}

export const defaultStep = { stepTitle: 'Default current step', link: '', active: false };
@Component({
    selector: 'progress-list',
    templateUrl: './progress-list.html',
    styleUrls: ['./progress-list.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [HrefComponent, CommonModule, SizeClassDirective]
})
export class ProgressListComponent implements OnChanges {
    /**
     * List of steps
     */
    @Input()
    steps: IProgressStep[] = [defaultStep];

    /**
     * Currently active stepisStepVisible : boolean
     */
    @Input()
    current: IProgressStep = defaultStep;

    /**
     * Notifier for step change
     */
    @Output()
    currentChange = new EventEmitter<IProgressStep>();

    /**
     * Cuerrently selected element index in the table
     */
    currentIndex: number | undefined;

    pick(step: IProgressStep): void {
        if (!step.link && this.isEnabled(step)) {
            this.current = step;
            this.currentChange.next(this.current);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.currentIndex = this.steps && this.current ? this.steps.indexOf(this.current) : -1;
    }

    isEnabled(step: IProgressStep): boolean {
        return step.active;
    }

    trackByIndex(index: number): number {
        return index;
    }
}
